(() => {
  let documentObserver = null;
  let documentObserverTimer = 0;
  let lateScanFrame = 0;

  // The customer form confirms its POST in Liquid. Forms uses its native success redirect.
  // Both go through Shopify's discount link, which preserves compatible cart discounts.
  const connectWelcomeSignup = () => {
    const section = document.querySelector('#memys-newsletter');
    if (!section || section.dataset.memysWelcomeHandled === 'true') return;
    const success = section.querySelector('[data-memys-registration-confirmed]');
    const inputs = section.querySelector('[data-memys-newsletter-inputs]');
    if (!success || !inputs) return;
    const url = new URL(window.location.href);
    const welcomeCallback = url.searchParams.get('memys_bienvenida');
    const returnedFromDiscount = welcomeCallback === '1' || welcomeCallback === '1#memys-newsletter';
    const registrationConfirmed = success.dataset.memysRegistrationConfirmed === 'true';
    if (!returnedFromDiscount && !registrationConfirmed) return;
    section.dataset.memysWelcomeHandled = 'true';

    if (returnedFromDiscount) {
      success.hidden = false;
      inputs.hidden = true;
      url.searchParams.delete('memys_bienvenida');
      url.searchParams.delete('customer_posted');
      url.hash = 'memys-newsletter';
      // Consume the callback so reload/back cannot apply a code the customer removed.
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      success.focus({ preventScroll: true });
      section.scrollIntoView({ block: 'start', behavior: 'instant' });
      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => section.scrollIntoView({ block: 'start', behavior: 'instant' }), { once: true });
      }
      return;
    }

    // Do not mark a code as applied or merely prefill a field: visit the official endpoint.
    const discountUrl = new URL(section.dataset.memysDiscountUrl, window.location.origin);
    if (discountUrl.origin !== window.location.origin || discountUrl.pathname !== '/discount/MEMYSCLIENTE') return;
    window.location.replace(discountUrl.href);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectWelcomeSignup, { once: true });
  } else {
    connectWelcomeSignup();
  }

  const formatLoyalty = () => {
    const line = document.querySelector('.honeypop-pp-text > p:first-child');
    if (!line) return false;
    if (line.dataset.memysFormatted === 'true') return true;

    const match = (line.textContent || '').match(/Gana\s+([\d.,]+)\s+puntos.*?~\s*([\d.,]+)\s*\$/i);
    if (!match) return false;

    const points = Number(match[1].replace(/\D/g, ''));
    const value = Number(match[2].replace(/\D/g, ''));
    if (!Number.isFinite(points) || !Number.isFinite(value)) return false;

    line.textContent = `${new Intl.NumberFormat('es-CL').format(points)} puntos · valor estimado $${new Intl.NumberFormat(
      'es-CL'
    ).format(value)}`;
    line.dataset.memysFormatted = 'true';
    return true;
  };

  const fixFrameNames = () => {
    const frames = [
      [document.querySelector('#merchantwidgetiframe'), 'Opiniones de Google sobre MemysHuevo'],
      [document.querySelector('#PBarNextFrame'), 'Barra privada de vista previa de Shopify'],
    ];

    frames.forEach(([frame, title]) => {
      if (frame && !frame.hasAttribute('title')) frame.setAttribute('title', title);
    });
  };

  const installNewsletterAnchor = () => {
    const section = document.querySelector('[id$="__section_Uh4FyJ"]');
    if (!section) return false;

    let anchor = document.querySelector('#memys-newsletter');
    if (!anchor) {
      anchor = document.createElement('span');
      anchor.id = 'memys-newsletter';
      anchor.setAttribute('aria-hidden', 'true');
      Object.assign(anchor.style, {
        display: 'block',
        position: 'relative',
        top: '-96px',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
      });
      section.prepend(anchor);
    }

    if (window.location.hash === '#memys-newsletter') {
      window.requestAnimationFrame(() => section.scrollIntoView({ block: 'start' }));
    }

    return true;
  };

  const focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';
  const syncSlideFocus = (slide) => {
    const isHidden = slide.getAttribute('aria-hidden') === 'true';

    slide.querySelectorAll(focusableSelector).forEach((element) => {
      if (isHidden) {
        if (!element.hasAttribute('data-memys-original-tabindex')) {
          element.dataset.memysOriginalTabindex = element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : 'none';
        }
        element.setAttribute('tabindex', '-1');
        return;
      }

      if (!element.hasAttribute('data-memys-original-tabindex')) return;
      const original = element.dataset.memysOriginalTabindex;
      if (original === 'none') element.removeAttribute('tabindex');
      else element.setAttribute('tabindex', original);
      delete element.dataset.memysOriginalTabindex;
    });
  };

  const slideObserver = new MutationObserver((records) => {
    records.forEach((record) => syncSlideFocus(record.target));
  });

  const fixCarouselFocus = () => {
    document.querySelectorAll('slideshow-slide[aria-hidden]').forEach((slide) => {
      if (slide.dataset.memysFocusObserved !== 'true') {
        slide.dataset.memysFocusObserved = 'true';
        slideObserver.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
      syncSlideFocus(slide);
    });
  };

  const fixProductSemantics = () => {
    const currentHeading = document.querySelector('h3.bulk-discount-title');
    if (currentHeading) {
      const replacement = document.createElement('h2');
      [...currentHeading.attributes].forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
      replacement.innerHTML = currentHeading.innerHTML;
      currentHeading.replaceWith(replacement);
    }

    if (document.querySelector('main[data-template^="collection"]')) {
      document.querySelectorAll('product-card [role="heading"][aria-level="3"]').forEach((heading) => {
        heading.setAttribute('aria-level', '2');
      });
    }
  };

  const enhanceBulkOptions = () => {
    const options = [...document.querySelectorAll('.bulk-option-card[data-qty]')];
    if (!options.length) return false;

    const syncPressedState = () => {
      options.forEach((option) => option.setAttribute('aria-pressed', String(option.classList.contains('active'))));
    };

    options.forEach((option) => {
      option.setAttribute('role', 'button');
      option.setAttribute('tabindex', '0');
      // The visible offer copy is already a complete accessible name. Keeping
      // a shorter aria-label caused a mismatch for voice-control users.
      option.removeAttribute('aria-label');

      if (option.dataset.memysAccessible === 'true') return;
      option.dataset.memysAccessible = 'true';
      option.addEventListener('click', () => window.requestAnimationFrame(syncPressedState));
      option.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        option.click();
      });
    });

    syncPressedState();
    return true;
  };

  const scanLateComponents = () => {
    const loyaltyRequired = Boolean(document.querySelector('main[data-template^="product"]'));
    const loyaltyReady = !loyaltyRequired || formatLoyalty();
    fixFrameNames();

    if (loyaltyReady && document.querySelector('#merchantwidgetiframe')) {
      documentObserver?.disconnect();
      documentObserver = null;
      if (documentObserverTimer) window.clearTimeout(documentObserverTimer);
      documentObserverTimer = 0;
      return true;
    }
    return false;
  };

  const scheduleLateScan = () => {
    if (lateScanFrame) return;
    lateScanFrame = window.requestAnimationFrame(() => {
      lateScanFrame = 0;
      scanLateComponents();
    });
  };

  const startLateComponentObserver = () => {
    if (scanLateComponents() || documentObserver || !document.body) return;

    documentObserver = new MutationObserver((records) => {
      const relevant = records.some((record) => [...record.addedNodes].some((node) =>
        node instanceof Element && (node.matches('.honeypop-pp-text, #merchantwidgetiframe, #PBarNextFrame') ||
          node.querySelector('.honeypop-pp-text, #merchantwidgetiframe, #PBarNextFrame'))
      ));
      if (relevant) scheduleLateScan();
    });
    documentObserver.observe(document.body, { childList: true, subtree: true });
    documentObserverTimer = window.setTimeout(() => {
      scanLateComponents();
      documentObserver?.disconnect();
      documentObserver = null;
      documentObserverTimer = 0;
    }, 12000);
  };

  const run = () => {
    installNewsletterAnchor();
    fixFrameNames();
    fixCarouselFocus();
    fixProductSemantics();
    enhanceBulkOptions();
  };

  const schedule = window.requestIdleCallback
    ? (callback) => window.requestIdleCallback(callback, { timeout: 1800 })
    : (callback) => window.setTimeout(callback, 900);

  schedule(run);
  schedule(startLateComponentObserver);
  window.addEventListener('load', scheduleLateScan, { once: true });
  ['pointerdown', 'keydown', 'touchstart'].forEach((eventName) => {
    window.addEventListener(eventName, scheduleLateScan, { once: true, passive: true });
  });
})();

